import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaPaperPlane, FaCheckCircle } from 'react-icons/fa';
import contactImg from "../assets/contact.webp";
import '../css/contactForm.css';

function ContactForm() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        let errs = {};
        let isValid = true;

        if (!formData.name.trim()) {
            errs.name = 'Please enter your name';
            isValid = false;
        }

        if (!formData.email.trim()) {
            errs.email = 'Please enter your email';
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errs.email = 'Please enter a valid email address';
            isValid = false;
        }

        if (!formData.subject.trim()) {
            errs.subject = 'Please enter a subject';
            isValid = false;
        }

        if (!formData.message.trim()) {
            errs.message = 'Please write a message';
            isValid = false;
        }

        setErrors(errs);
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            setIsSubmitted(true);
            setFormData({
                name: '',
                email: '',
                subject: '',
                message: ''
            });
            setTimeout(() => setIsSubmitted(false), 5000);
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
        if (errors[e.target.id]) {
            setErrors({ ...errors, [e.target.id]: null });
        }
    };

    return (
        <section className="modern-contact-section py-5">
            <Container>
                <div className="text-center mb-5">
                    <span className="badge-tag">Connect With Us</span>
                    <h2 className="contact-headline mt-2">Get In Touch & Share Your Heart</h2>
                    <p className="text-muted max-w-600 mx-auto">
                        Whether you want to sponsor a child, visit our orphanage, or ask questions, we would love to hear from you.
                    </p>
                </div>

                <div className="contact-main-card">
                    <Row className="g-0">
                        {/* Left Column: Direct Info & Image */}
                        <Col lg={5} className="contact-info-panel p-4 p-md-5">
                            <h3 className="text-white fw-bold mb-4">Contact Information</h3>
                            <p className="text-slate-300 mb-4" style={{ color: '#cbd5e1' }}>
                                Reach out directly through any of our channels or send us a message through the form.
                            </p>

                            <div className="contact-info-list mb-4">
                                <div className="info-item">
                                    <div className="info-icon">
                                        <FaPhoneAlt />
                                    </div>
                                    <div>
                                        <span className="info-title">Call or WhatsApp</span>
                                        <a href="tel:+919603040740" className="info-val">+91 96030 40740</a>
                                    </div>
                                </div>

                                <div className="info-item">
                                    <div className="info-icon">
                                        <FaEnvelope />
                                    </div>
                                    <div>
                                        <span className="info-title">Email Address</span>
                                        <a href="mailto:info@lovingarmsorphanage.org" className="info-val">info@lovingarmsorphanage.org</a>
                                    </div>
                                </div>

                                <div className="info-item">
                                    <div className="info-icon">
                                        <FaMapMarkerAlt />
                                    </div>
                                    <div>
                                        <span className="info-title">Orphanage Location</span>
                                        <span className="info-val">Rajampeta Town, YSR Kadapa District, Andhra Pradesh 516115, India</span>
                                    </div>
                                </div>
                            </div>

                            <div className="contact-panel-img-wrap mt-auto">
                                <img
                                    src={contactImg}
                                    alt="Loving Arms Children"
                                    className="panel-img"
                                />
                            </div>
                        </Col>

                        {/* Right Column: Contact Form */}
                        <Col lg={7} className="contact-form-panel p-4 p-md-5">
                            {isSubmitted && (
                                <div className="alert-success-modern mb-4">
                                    <FaCheckCircle className="me-2" /> Message Sent Successfully! We will respond shortly.
                                </div>
                            )}

                            <h3 className="fw-bold mb-4" style={{ color: 'var(--dark-navy)' }}>Send a Message</h3>

                            <form onSubmit={handleSubmit} noValidate>
                                <Row className="g-3">
                                    <Col md={6}>
                                        <label className="form-label-modern" htmlFor="name">Your Name</label>
                                        <input
                                            type="text"
                                            className={`form-input-modern ${errors.name ? 'input-error' : ''}`}
                                            id="name"
                                            placeholder="John Doe"
                                            value={formData.name}
                                            onChange={handleChange}
                                            autoComplete="name"
                                        />
                                        {errors.name && <span className="error-text">{errors.name}</span>}
                                    </Col>

                                    <Col md={6}>
                                        <label className="form-label-modern" htmlFor="email">Your Email</label>
                                        <input
                                            type="email"
                                            className={`form-input-modern ${errors.email ? 'input-error' : ''}`}
                                            id="email"
                                            placeholder="john@example.com"
                                            value={formData.email}
                                            onChange={handleChange}
                                            autoComplete="email"
                                        />
                                        {errors.email && <span className="error-text">{errors.email}</span>}
                                    </Col>

                                    <Col xs={12}>
                                        <label className="form-label-modern" htmlFor="subject">Subject</label>
                                        <input
                                            type="text"
                                            className={`form-input-modern ${errors.subject ? 'input-error' : ''}`}
                                            id="subject"
                                            placeholder="How can we help?"
                                            value={formData.subject}
                                            onChange={handleChange}
                                        />
                                        {errors.subject && <span className="error-text">{errors.subject}</span>}
                                    </Col>

                                    <Col xs={12}>
                                        <label className="form-label-modern" htmlFor="message">Message</label>
                                        <textarea
                                            rows="5"
                                            className={`form-input-modern ${errors.message ? 'input-error' : ''}`}
                                            id="message"
                                            placeholder="Write your words or inquiry here..."
                                            value={formData.message}
                                            onChange={handleChange}
                                        ></textarea>
                                        {errors.message && <span className="error-text">{errors.message}</span>}
                                    </Col>

                                    <Col xs={12} className="mt-4">
                                        <button className="btn-modern-primary w-100 py-3" type="submit">
                                            <FaPaperPlane className="me-2" /> Send Message
                                        </button>
                                    </Col>
                                </Row>
                            </form>
                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
    );
}

export default ContactForm;
